module.exports = __webpack_public_path__ + "static/media/dashboard_welcome.bc7d7cd0.svg";